import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
  import TextRenderer from '@/components/editor/TextRenderer.vue'
  import useEditor from '@/composables/useEditor'
  // @ts-ignore
  import DatePicker from 'vue2-datepicker'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import useCourse from '@/composables/useCourse'
  import type { EditorStatePayload } from '@/services/interfaces/Course'
  import CourseApi from '@/services/api/CourseApi'
  import { CourseModule } from '@/store/modules/course'
  import { EditorModule } from '@/store/modules/editor'
  import * as Sentry from '@sentry/vue'
  import eventBus from '@/main'
  import useI18n from '@/composables/useI18n'
  import { useRoute } from 'vue-router/composables'
  import useCommonMixin from '@/composables/useCommonMixin'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FollowupModal',
  emits: ['close'],
  setup(__props, { emit }) {

  const route = useRoute()
  const { followUp, currentEditorLesson } = useEditor(route)
  const { checkmark, closeIcon } = useIcons()
  const { lessonId, currentCourseId, moduleId } = useCourse()
  const { translateString } = useI18n()
  const { closeModal } = useCommonMixin()

  

  const selectedDate = ref<Date | null>(followUp.value?.date ? new Date(followUp.value?.date) : null)
  const isSaving = ref(false)
  const comment = ref(followUp.value?.comment || '')

  const followUpPayload = computed(() => ({
    lessonId: lessonId.value,
    date: `${selectedDate.value?.getFullYear() ?? ''}-${((selectedDate.value?.getMonth() ?? 0) + 1)
      .toString()
      .padStart(2, '0')}-${selectedDate.value?.getDate().toString().padStart(2, '0')}`,
    comment: comment.value,
  }))

  const onSave = async () => {
    if (selectedDate.value && comment.value) {
      isSaving.value = true
      const isEditing = !!followUp.value?.id
      try {
        if (followUp.value?.id) {
          await CourseApi.updateFollowup(followUp.value!.id, followUpPayload.value)
        } else {
          await CourseApi.createFollowup(followUpPayload.value)
        }
        const lesson = await CourseApi.getLesson(currentCourseId.value, moduleId.value, lessonId.value)
        CourseModule.setCurrentLesson(lesson)
        EditorModule.setCurrentLesson(lesson)
        if (isEditing) eventBus.$toasted.success(translateString('editor.messages.followupUpdatedSuccessfully'))
        else eventBus.$toasted.success(translateString('editor.messages.followupCreatedSuccessfully'))
      } catch (err) {
        Sentry.captureException(err)
      } finally {
        isSaving.value = false
        emit('close')
      }
    }
  }

  const mutateAndQueueFunc = (data: EditorStatePayload) => {
    comment.value = data.value as string
  }

return { __sfc: true,route, followUp, currentEditorLesson, checkmark, closeIcon, lessonId, currentCourseId, moduleId, translateString, closeModal, emit, selectedDate, isSaving, comment, followUpPayload, onSave, mutateAndQueueFunc, computed, ref, TextRenderer, useEditor, DatePicker, KetchUpButton, SVGRenderer, useIcons, LoadingSpinner, useCourse, CourseApi, CourseModule, EditorModule, Sentry, eventBus, useI18n, useRoute, useCommonMixin }
}

})